module.exports = __webpack_public_path__ + "static/bank danamon-4b1497535b51634c02eda476385fcab4.png";